<template>
  <v-sheet>
    <iframe src="/ccas/docs/" height="900" width="900" name="CCAS Documentation" scrolling="auto" sandbox="allow-scripts"></iframe>
  </v-sheet>
</template>

<script>
export default {
name: "help"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/help.vue